module.exports = __webpack_public_path__ + "img/thumbnail_GreaterRhea_f_leucistic.87f51187.png";